import React from "react";
import styled from "styled-components";
import { IActionButton } from ".";
import { IHorizontal } from "./Props";

interface IClickContainer {
    isClickable?: boolean;
}

const MainContainer = styled.div`
    display: flex;
    justify-content: center;
    flex-direction: column;
    margin: 1vw;
    width: 95%;
`;

const StyledContainer = styled.div<IClickContainer>`
    display: flex;
    -webkit-flex-wrap: nowrap;
    flex-wrap: nowrap;
    height: 5vw;
    justify-content: space-around;
    align-content: center;
    align-items: center;
    border-radius: 2vw;
    background: white;
    border: 1px gray solid;
    width: 100%;

    @media (max-width: 800px) {
        min-height: 11vw;
    }

    cursor: ${(props) => `${props.isClickable ? "pointer" : "arrow"}`};

    &:hover {
        border-color: #6c88dd;
        background-color: aliceblue;
    }
`;

const ExtraContainer = styled.div`
    display: inline-flex;
    background-color: white;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px black solid;
    border-left: 1px black solid;
    border-right: 1px black solid;
    border-radius: 2vw;
    padding-left: 2%;
    padding-rigth: 1%;
`;

const Title = styled.h2`
    color: #663838;
    font-weight: bold;
    @media (max-width: 500px) {
        font-size: 1rem;
    }
`;

const Date = styled.div`
    color: black;
    font-weight: 300;
    margin: 6px 0;
    @media (max-width: 500px) {
        font-size: 0.8rem;
    }
`;

const Description = styled.p`
    color: black;
    font-weight: bold;
    @media (max-width: 500px) {
        font-size: 0.75rem;
    }
`;

const ActionButton = styled.button`
    max-width: 25%;
    margin: 0 5px;
    padding: 8px 14px;
    background: rgba(0, 0, 0, 0.59);
    color: #fff;
    cursor: pointer;
    border: 3px solid black;
    outline: 0;
    font-weight: 300;
    border-radius: 13px;
    font-family: "Roboto", sans-serif;
    background-color: transparent;
    color: black;

    :hover {
        opacity: 0.8;
    }
    :active {
        background: #ef3c34;
    }
`;

const StyledPhoto = styled.img`
    width: 4.5vw;
    height: auto;
    padding: 1vw;

    @media (max-width: 800px) {
        width: 10vw;
    }
`;

const renderGroup = (
    customGroup?: JSX.Element[],
    buttons?: IActionButton[]
) => {
    if (customGroup) return customGroup;

    if (buttons)
        return buttons.map(({ label, onClick }: any, index: number) => (
            <ActionButton
                onClick={onClick}
                key={index}
                style={{ maxWidth: "100%" }}
            >
                {label}
            </ActionButton>
        ));

    return null;
};

const HorizontalCard: React.FC<IHorizontal> = ({
    title,
    date,
    description,
    extraText,
    buttons,
    srcImg,
    icon,
    onClick,
    style,
    customGroup,
}) => (
    <MainContainer>
        <StyledContainer
            isClickable
            onClick={() => onClick && onClick()}
            style={style}
        >
            {icon ? icon : <StyledPhoto src={srcImg} />}

            <Title>{title}</Title>
            <Date>{date}</Date>
            <Description>{description}</Description>
        </StyledContainer>
        {(extraText || buttons || customGroup) && (
            <ExtraContainer>
                {extraText && <span>{extraText}</span>}
                {(buttons || customGroup) && (
                    <div style={{ display: "flex", height: "85%" }}>
                        {renderGroup(customGroup, buttons)}
                    </div>
                )}
            </ExtraContainer>
        )}
    </MainContainer>
);

export default HorizontalCard;
